import styled, { keyframes } from "styled-components";

export const Container = styled.div`
  padding: 1rem;

  h1{
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    border-bottom: 1px solid #96989A;
    margin-bottom: 40px;
  }
`;

export const Forms = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 32px;

  .content {
    display: flex;
    flex-direction: column;
    gap: 32px;
    width: 100%;
  }

  .buttons{
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
  }
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;
  width: 100%;

  button{
    background-color: var(--color-primary);
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    line-height: normal;
    cursor: pointer;
    padding: 8px 10px;
    border-radius: 4px;
    border: none;
    min-width: 220px;
    display: flex;
    justify-content: center;
  }

  .load{
      border: 2px solid #fff;
      border-radius: 50%;
      border-top: 2px solid #A0A0A0;
      width: 20px;
      height: 20px;

      animation: ${spin} 1s linear infinite;
  }
`;
